import TagManagerIndex from "@/Tags/TagManagerIndex.vue";

export default [
  {
    path: "/company/tags",
    name: "TagManagerIndex",
    component: TagManagerIndex,
    meta: {
      permissionRoles: ["account_settings"]
    }
  }
];
